import React, { FC } from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import { useGetApplication } from '~/controllers/wizard';
import { DocumentInput } from '~/components';
import buildNamePath from '~/utils/buildNamePath';
import ReviewItemCheckbox from '~/pages/ksa/review/components/ReviewItemCheckbox';

const BeneficialOwnerReviewAdditionalInformation: FC = () => {
  const { t } = useTranslation('ksaReview');
  const applicationQuery = useGetApplication();

  if (!applicationQuery.data) {
    return null;
  }
  const hasBeneficialOwners = !isEmpty(
    applicationQuery?.data?.payload?.shareholders?.beneficialOwners ?? []
  );
  const beneficialOwnerAdditionalInfo =
    applicationQuery?.data?.payload?.shareholders?.additionalInfo;

  return (
    <>
      <Typography.Title level={4}>{t('Additional information').toUpperCase()}</Typography.Title>
      <ReviewItemCheckbox
        name={additionalInfoFiles}
        label={t('Additional information files')}
        disabled={!hasBeneficialOwners}
      >
        {beneficialOwnerAdditionalInfo?.files ? (
          <div onClick={(e) => e.preventDefault()} aria-hidden>
            <DocumentInput
              name=""
              maxCount={beneficialOwnerAdditionalInfo?.files?.length}
              value={beneficialOwnerAdditionalInfo.files}
              noRemove
              multiple={false}
              disabled
            />
          </div>
        ) : undefined}
      </ReviewItemCheckbox>
      <ReviewItemCheckbox
        name={additionalInfoComment}
        label={t('Comment')}
        disabled={!hasBeneficialOwners}
      >
        {beneficialOwnerAdditionalInfo?.comment}
      </ReviewItemCheckbox>
    </>
  );
};

const additionalInfo = 'additionalInfo';
const n = buildNamePath(['reviewShareholders', additionalInfo]);
const additionalInfoFiles = n('files');
const additionalInfoComment = n('comment');

export default BeneficialOwnerReviewAdditionalInformation;
